import { useState, useEffect, useRef } from "react";
import downArrow from "../../assets/img/icons/down-arrow-backup-2-svgrepo-com-black.svg";
import fileIcon from "../../assets/img/icons/file-xmark-alt-1-svgrepo-com.svg";
import pdfFile from "../../assets/img/icons/document-pdf-svgrepo-com.svg";
import xlsFile from "../../assets/img/icons/xls-file-format-symbol-svgrepo-com.svg";
import "./FilterButton.css";
import { CSVLink } from "react-csv";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

// Define prop types for the ExportDocs component
interface ExportDocsProps {
   formattedData: Array<Record<string, any>>; // Array of objects for the CSV data
   headers: Array<{ label: string, key: string }>; // Array of headers for the CSV
   clickHandler: () => void; // Function for exporting PDF or Excel
}

const ExportDocs: React.FC<{
   formattedData: any[];
   headers: any[];
   clickHandler: () => void;
}> = ({ formattedData, headers, clickHandler }) => {
   const [showModal, setShowModal] = useState(false);
   const modalRef = useRef<HTMLUListElement | null>(null);
   const buttonRef = useRef<HTMLDivElement | null>(null); // Ref for the button that toggles the modal

   // Close the modal if the user clicks outside
   useEffect(() => {
      const handleClickOutside = (event: MouseEvent) => {
         // If clicked outside the modal and button, close the modal
         if (
            modalRef.current &&
            !modalRef.current.contains(event.target as Node) &&
            buttonRef.current &&
            !buttonRef.current.contains(event.target as Node)
         ) {
            setShowModal(false);
         }
      };

      document.addEventListener("mousedown", handleClickOutside);

      // Cleanup the event listener when the component unmounts
      return () => {
         document.removeEventListener("mousedown", handleClickOutside);
      };
   }, []);

   return (
      <div className="dropdown export-div">
         <div
            ref={buttonRef} // Assigning the button ref
            className="btn btn-light fw-medium d-inline-flex align-items-center justify-content-between"
            onClick={() => {
               // Toggling the modal visibility when button is clicked
               setShowModal(!showModal);
            }}
         >
            <i className="file-icon d-flex justify-content-center align-items-center">
               <img src={fileIcon} alt="file-icon" style={{ width: "15px", height: "15px" }} />
            </i>
            <span className="pe-2 ps-2">Export</span>
            <i className="d-flex justify-content-center align-items-center">
               <img src={downArrow} alt="downArrow" style={{ width: "13px", height: "13px" }} />
            </i>
         </div>

         {showModal && (
            <ul className="export-modal p-3" ref={modalRef}>

               <li style={{ listStyle: "none", cursor: "pointer" }} onClick={() => setShowModal(!showModal)}>
                  <CSVLink
                     data={formattedData}
                     headers={headers}
                     filename="transactions.csv"
                     className="d-flex gap-2 modal-text"
                     style={{ textDecoration: "none" }}
                  >

                     <i className="file-icon d-flex justify-content-center align-items-center">
                        <img src={xlsFile} alt="file-icon" style={{ width: "15px", height: "15px" }} />
                     </i>
                     <span>
                        Export as Excel
                     </span>
                  </CSVLink>
               </li>
               <li style={{ listStyle: "none", cursor: "pointer" }} onClick={() => setShowModal(!showModal)}>

                  <div
                     className="d-flex gap-2 modal-text"
                     onClick={clickHandler}
                  >
                     <i className="file-icon d-flex justify-content-center align-items-center">
                        <img src={pdfFile} alt="file-icon" style={{ width: "15px", height: "15px" }} />
                     </i>

                     <span>
                        Export as PDF
                     </span>

                  </div>

               </li>
            </ul>
         )}
      </div>
   );
};

export default ExportDocs;
